import React, { Component } from 'react';
import { SpinLoader } from 'app/components';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { CodetableListComponentProps } from './types';
import { CodetableListItems } from 'app/area/import-mappings/list-items/codetable-list-items';
import { ImportMappingsHeader } from 'app/area/import-mappings/list-items/components/import-mappings-header';
import { getModifiedItem } from 'app/area/import-mappings/selectors';
import { CurrentImportCode } from 'app/area/import-mappings/list-items/current-import-code';
import { ImportMapping, ImportMappingType } from 'app/area/import-mappings/types-store';
import styles from './codetable-list-component.scss';
import { removeAllEnters, setModifyImportMappingType } from 'app/area/import-mappings/list-items/modify-import-code';

export class CodetableListComponent extends Component<CodetableListComponentProps> {
  public render() {
    const { codetable, importSet, isHierarchy, isHierarchyMode, isCodetableWithCategory, metadata,
      shouldRenderSpinLoader, codeListBranch, codeListBranchState, itemAccess,
      fetchingItemAccess, translation, displayNoContent, numberOfResults, currentCode,
      updating, modifiedItems, validation, loadFromParent, expandCodeItem, setCurrentCode, clearCurrentCode,
      modifyItem, saveItemChanges, clearValidation
    } = this.props;

    const importCodeContainer = () => {
      const modifiedItem = getModifiedItem(modifiedItems, currentCode);

      const modifyImportMapping = (modifiedImportMapping: ImportMapping[]) => {
        const modifiedData = modifiedImportMapping.find(item => item.type !== ImportMappingType.Init
          && item.type !== ImportMappingType.New);

        modifyItem({
          id: currentCode?.id,
          codetable: currentCode?.codetableId ?? undefined,
          description: currentCode?.description ?? undefined,
          importMapping: modifiedImportMapping
        });

        saveItemChanges(
          importSet?.value,
          currentCode?.codetableId,
          currentCode?.id,
          modifiedData.importNumber,
          setModifyImportMappingType(modifiedData),
          removeAllEnters(modifiedData.externalValue), modifiedData.existingExternalValue, translation.error
        );
      };

      const importMapping = (modifiedItem ? modifiedItem.importMapping : currentCode?.importMapping) || [];

      return <div className="row mt-15">
        {numberOfResults !== undefined
          && <>
            <div className="col-8">
              <div className={`${styles.alertInfo} mt-3 mb-3`}>
                <p>{translation.changes_saved}</p>
              </div>
              <ImportMappingsHeader
                numberOfResults={numberOfResults}
                noHitsLabel={translation.no_hits}
                translation={translation} />
            </div>
            <div className="col-4" />
          </>}
        <div className="col-8">
          <div className={styles.listContainer}>
            <div className={styles.listHolder}>
              <div className={styles.listItems}>
                <CodetableListItems
                  codetable={codetable}
                  metadata={metadata}
                  currentCode={currentCode}
                  itemAccess={itemAccess}
                  fetchingItemAccess={fetchingItemAccess}
                  treeDepthLevel={0}
                  hierarchyMetadata={[]}
                  isZebra={undefined}
                  isHierarchyMode={isHierarchyMode}
                  isHierarchy={isHierarchy}
                  isCodetableWithCategory={isCodetableWithCategory}
                  codeListBranchState={codeListBranchState}
                  codeListBranch={codeListBranch}
                  loadFromParent={loadFromParent}
                  expandCodeItem={expandCodeItem}
                  parentId={undefined}
                  setCurrentCode={setCurrentCode}
                  clearValidation={clearValidation}
                  modifiedItems={modifiedItems}
                  updating={updating}
                  validation={validation}
                  translation={translation} />
              </div>
            </div>
          </div>
        </div>

        {!!currentCode && <div className="col-4">
          <CurrentImportCode
            currentCode={currentCode}
            updating={updating}
            importMapping={importMapping}
            modifyImportMapping={modifyImportMapping}
            clearCurrentCode={clearCurrentCode}
            clearValidation={clearValidation}
            setCurrentCode={setCurrentCode}
            validation={this.props.validation}
            translation={translation} />
        </div>}
      </div>;
    };

    return <SearchFilters {...this.props}>
      <div className={`${styles.codetableListContainer} ${styles.codetableListCenter}`}>
        <div className={styles.codetableListHolder}>
          {shouldRenderSpinLoader ? <SpinLoader /> : undefined}
          {codeListBranch?.length > 0 && numberOfResults > 0 && importCodeContainer()}
          {displayNoContent && <p className="no-content">
            {translation.choose_all_values}
          </p>}
        </div>
      </div>
    </SearchFilters>;
  }
}
